import { forwardRef } from 'react';
import { motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import styles from './Tag.module.css';

export const Tag = forwardRef(function Tag(
  {
    children,
    className,
    onClick,
    textOnly = false,
    selected = false,
    variant,
    as,
    ...props
  },
  ref
) {
  const Component = as ? as : motion.span;
  const isClickable = Boolean(onClick);

  return (
    <Component
      ref={ref}
      data-clickable={isClickable}
      className={cn(
        styles.tag,
        selected && styles.selected,
        textOnly && styles.textOnly,
        className
      )}
      data-variant={variant}
      onClick={onClick}
      {...props}
    >
      {children}
    </Component>
  );
});
